import React from "react";

export default function RelicIcon({ className, size = 14, strokeWidth = 1.477, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0.6 0.7 14.5 14.5"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M13.786 10.504V5.252a1.31 1.31 0 0 0-.657-1.135L8.534 1.49a1.31 1.31 0 0 0-1.313 0L2.626 4.117a1.31 1.31 0 0 0-.657 1.135v5.252a1.31 1.31 0 0 0 .657 1.136l4.595 2.626a1.31 1.31 0 0 0 1.313 0l4.595-2.626a1.31 1.31 0 0 0 .657-1.136" />
      <path d="m2.147 4.569 5.731 3.315 5.731-3.315M7.877 14.495V7.878" />
    </svg>
  );
}
